module.exports = __webpack_public_path__ + "static/media/SC-PRO.b9e56469.jpg";